import { render, staticRenderFns } from "./ModalCreateQuickProtocol.vue?vue&type=template&id=628feeb2&scoped=true"
import script from "./ModalCreateQuickProtocol.vue?vue&type=script&lang=js"
export * from "./ModalCreateQuickProtocol.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateQuickProtocol.vue?vue&type=style&index=0&id=628feeb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628feeb2",
  null
  
)

export default component.exports